/* Sneaker-Vorlage: endloses Bilder-Band */
if (!customElements.get('scrolling-content')) {
  class ScrollingContent extends HTMLElement {
  constructor() {
  super();
  this.offset = 0;
  this._raf = null;
  this._resizeObserver = null;
  }
  connectedCallback() {
  this.speed = parseFloat(this.dataset.speed) || 0.3;
  this.direction = this.dataset.direction || 'end-to-start';
  this.gap = parseInt(this.dataset.gap, 10) || 10;
  this.inner = this.querySelector('.custom-scrolling-content__inner');
  this.primary = this.querySelector('[data-strip="primary"]');
  if (!this.inner || !this.primary) return;
  this._animate = this._animate.bind(this);
  this._measure();
  this._observe();
  this._watchResize();
  this._hookImageLoads();
  this._loadImagesOnApproach();
  }
  disconnectedCallback() {
  if (this._raf) cancelAnimationFrame(this._raf);
  if (this._io) this._io.disconnect();
  if (this._loaderIo) this._loaderIo.disconnect();
  if (this._resizeObserver) this._resizeObserver.disconnect();
  }
  _loadImagesOnApproach() {
  this._loaderIo = new IntersectionObserver(
  (entries, obs) => {
  if (entries.some((e) => e.isIntersecting)) {
  this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
  img.loading = 'eager';
  });
  obs.disconnect();
  }
  },
  { rootMargin: '400px 0px' }
  );
  this._loaderIo.observe(this);
  }
  _hookImageLoads() {
  const imgs = this.primary.querySelectorAll('img');
  const reMeasure = () => { this._measure(); };
  imgs.forEach((img) => {
  if (!img.complete) {
  img.addEventListener('load', reMeasure, { once: true });
  img.addEventListener('error', reMeasure, { once: true });
  }
  });
  }
  _measure() {
  this.stripWidth = this.primary.scrollWidth;
  }
  _observe() {
  this._io = new IntersectionObserver(
  (entries) => {
  entries.forEach((entry) => {
  if (entry.isIntersecting) {
  this._start();
  } else {
  this._stop();
  }
  });
  },
  { threshold: 0 }
  );
  this._io.observe(this);
  this._ioFallback = setTimeout(() => {
  if (!this._raf) this._start();
  }, 800);
  }
  _watchResize() {
  this._resizeObserver = new ResizeObserver(() => {
  this._measure();
  });
  this._resizeObserver.observe(this.primary);
  }
  _start() {
  if (this._raf) return;
  if (this._ioFallback) { clearTimeout(this._ioFallback); this._ioFallback = null; }
  this._lastTime = performance.now();
  this._raf = requestAnimationFrame(this._animate);
  }
  _stop() {
  if (this._raf) {
  cancelAnimationFrame(this._raf);
  this._raf = null;
  }
  }
  _animate(now) {
  this._raf = requestAnimationFrame(this._animate);
  if (!this.stripWidth || this.stripWidth <= 0) {
  this._measure();
  this._lastTime = now;
  return;
  }
  const delta = now - this._lastTime;
  this._lastTime = now;
  const clampedDelta = Math.min(delta, 100);
  const dist = this.speed * (clampedDelta / 16.667);
  if (this.direction === 'end-to-start') {
  this.offset -= dist;
  } else {
  this.offset += dist;
  }
  const limit = this.stripWidth;
  if (this.direction === 'end-to-start') {
  if (this.offset <= -limit) this.offset += limit;
  } else {
  if (this.offset >= limit) this.offset -= limit;
  }
  this.inner.style.transform = `translateX(${this.offset}px)`;
  }
  }
  customElements.define('scrolling-content', ScrollingContent);
  }
